// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3fzSS","input":"styles_input__2ZNNx"};